import { render, staticRenderFns } from "./MailTemplateEditor.vue?vue&type=template&id=780feed0&scoped=true&"
import script from "./MailTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./MailTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MailTemplateEditor.vue?vue&type=style&index=1&id=780feed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780feed0",
  null
  
)

/* custom blocks */
import block0 from "./MailTemplateEditor.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./MailTemplateEditor.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
